import { createTheme } from "@mui/material/styles";
import '@mui/x-data-grid/themeAugmentation';
const theme = createTheme({
  palette: {
    primary: {
      main: "#0092C8",
    },
    secondary: {
      main: "#2C2C2C",
    },
    // .
    // Add more color configurations or other theme customizations if needed
    primaryLuBlue: { main: "#0093C8" },
    primaryLuBlue700: { main: "#007AA7" },
    primaryLuBlue100: { main: "#E6F5FA" },
    primaryBlack: { main: "#2C2C2C" },
    primaryGrey: { main: "#556670" },
    tertiaryGrey: { main: "#9EACB4" },
    tertiaryLightGrey: { main: "#ECEDEF" },
    tertiaryGrey2: { main: "#F4F8F9" },
    tertiaryLightBlue: { main: "#F4FCFF" },
    primaryIconicBlack: { main: "#022943" },
    backgroundDefault: { main: "#E8F2FD" },
    whiteDefault: { main: "#FFFFFF" },
  },
  typography: {
    fontFamily: "Jost, sans-serif",
  },
  components: {
    MuiDataGrid: {
			styleOverrides: {
				root: {
					borderRadius: 0,
				},
			},
		},
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
          lineHeight: "18px",
          top:-5,
          '&[data-shrink="true"]': {
            top: 0,
          }
        },
        sizeSmall: {top:0}
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "4px 16px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: "Jost, sans-serif !important",
          height:"23px !important", 
          lineHeight:"23px !important",
          paddingBottom: "8.5px !important",
          paddingTop: "8.5px !important",
          paddingLeft:"14px !important",
          paddingRight:"14px !important",
          fontSize:16
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        input: {
          padding:"2.5px 4px 2.5px 8px !important",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&.MuiDialogActions-action": {
            backgroundColor: "#0092C8",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#0078A6",
            },
          },
        },
      },
    },
  },
});

export default theme;
